import { EJReportTypeItem } from './EJReportTypeItem'

export const ConcreteTest = new EJReportTypeItem({
  id: '36250de3-3c9a-4846-8d2e-0609805cc3d0',
  classType: 'ConcreteTest',
  label: 'testId',
  type: 'Concrete Test',
})

export const ConcretePlacement = new EJReportTypeItem({
  id: '6bbb49ea-b12d-46c1-b126-9b2bb5a5f519',
  classType: 'ConcretePlacement',
  label: 'placementId',
  type: 'Concrete Placement',
})

export const DensityLot = new EJReportTypeItem({
  id: '5ea7b116-ff6d-4f96-9d15-c461ffde821d',
  classType: 'Lot',
  label: 'lotId',
  type: 'Density Lot',
})

export const DailyInspectionControlPoint = new EJReportTypeItem({
  id: '47e265ea-ee5e-42e1-84e5-32d8c5421e9c',
  classType: 'DailyInspectionControlPoint',
  label: 'controlPointId',
  type: 'Control Point',
})

export const DailyInspectionInspection = new EJReportTypeItem({
  id: '4939892d-e5ec-4d3b-89f4-b4665a709d91',
  classType: 'DailyInspectionInspection',
  label: 'inspectionId',
  type: 'Inspection',
})

export const Gradation = new EJReportTypeItem({
  id: 'aa2b6a6e-e902-4b10-8ec7-5013ebfa77f1',
  classType: undefined,
  label: undefined,
  type: 'Gradation',
})
